"use client";

import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogFooter,
} from "@components/ui/dialog";

import { Button } from "@components/ui/button";
import TextComponent from "./Textcomponent";
import { ConfirmDialogProps } from "./CommonTypes";

const Confirmation: React.FC<ConfirmDialogProps> = ({
  title = "",
  text,
  confirmAction,
  rejectAction,
  confirmText = "Confirm",
  rejectText = "Cancel",
  show = false,
  closeDialog,
}) => {
  function reject() {
    if (rejectAction) {
      rejectAction();
    } else {
      if (closeDialog) {
        closeDialog();
      }
    }
  }

  return (
    <>
      <Dialog open={show} onOpenChange={closeDialog}>
        <DialogContent className="sm:max-w-[425px] pt-4">
          <DialogTitle>{title ? title : ""}</DialogTitle>
          <div className="text-start text-sm pt-4">
            <TextComponent htmlContent={text} />
          </div>
          <DialogFooter>
            <Button variant="secondary" onClick={() => reject()}>
              {rejectText}
            </Button>
            <Button variant="default" onClick={confirmAction}>
              {confirmText}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Confirmation;
